import React, { useState, useEffect } from 'react';
import {  useDispatch, useSelector  } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import {
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  FormControlLabel,
  Checkbox,
  makeStyles
} from '@material-ui/core';
import { checkHash, createRegistration } from '../actions/registration.action';
import { addAlert } from '../actions/alerts.action';
import { trimWhitespaces } from '../utils/strings';
import { PRIVACY_POLICY } from '../utils/const';

const Registration = props => {
  const [ loginName, setLoginName ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ passwordSecondTime, setPasswordSecondTime ] = useState('');
  const [ isUserNameValid, setIsUserNameValid ] = useState(true);
  const [ gdpr, setGdpr ] = useState(false);
  const registrationHash = props.match.params.hash;
  const employee = useSelector(state => state.employee);
  const alerts = useSelector(state => state.alert);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(checkHash(registrationHash, props.history));
  }, [ dispatch, registrationHash, props.history ]);

  const handleOnChangeLoginName = event => {
    setLoginName(trimWhitespaces(event.target.value));
    setIsUserNameValid(trimWhitespaces(event.target.value).length !== 0);
  };

  const handleOnPaste = event => {
    event.preventDefault();
  };

  const handleOnChangePassword = event => setPassword(event.target.value);
  const handleOnChangePasswordAgain = event => setPasswordSecondTime(event.target.value);
  const handleGdprChecked = event => setGdpr(event.target.checked);

  const handleRegister = async () => {
    if (loginName.length === 0) {
      return dispatch(addAlert({ message: t(`settings.loginName.missing`), severity: 'error' }));
    }

    if (!gdpr) {
      return dispatch(addAlert({ message: t('settings.qdpr.not_accepted'), severity: 'error' }));
    }

    if (password && password === passwordSecondTime) {
      const registrationData = {
        password,
        employeeId: employee.id,
        loginName
      };

      return dispatch(createRegistration(registrationHash, registrationData, props.history));
    } else {
      return dispatch(
        addAlert({ message: t(`common.alert.passwords_missmatch`), severity: 'error' })
      );
    }
  };

  const useStyles = makeStyles(theme => ({
    root: {
      justify: 'center',
      minHeight: '100vh'
    },
    paper: {
      padding: '20px',
      width: '250px'
    },
    textField: {
      width: '100%',
      marginTop: '10px',
      marginBottom: '10px'
    },
    helpText: {
      maxWidth: '600px',
      textAlign: 'justify',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 20px 0px 20px'
      }
    },
    welcomeText: {
      marginBottom: '30px',
      textAlign: 'center'
    },
    gdprText: {
      madgin: 0,
      fontSize: '12px'
    },
    checkBox: {
      padding: '0 0 0 5px',
      transform: 'scale(0.8)',
      '&.Mui-checked': {
        color: '#99B64E'
      }
    }
  }));

  const classes = useStyles();

  if (!employee || (alerts && alerts
    .filter(alert => alert.message === t('registration.alert.already_registered'))
    .length !== 0)) {
    return <div></div>;
  }

  return (
    <Grid container
      className={ classes.root }
      justifyContent="center"
      alignItems="center"
      direction={ 'column' }>
      <Grid item>
        <Typography className={ classes.welcomeText } variant="h5" component="h3">
          <Trans i18nKey={ 'registration.welcome' } values={ { name: employee.name } }/>
        </Typography>
      </Grid>
      <Grid item>
        <Typography className={ classes.helpText } component="h6">
          {t('registration.description')}
        </Typography>
      </Grid>
      <Paper className={ classes.paper }>
        <Grid container direction={ 'column' }>
          <TextField
            onPaste={ handleOnPaste }
            label={ t('registration.label.user_name') }
            className={ classes.textField }
            onChange={ handleOnChangeLoginName }
            value={ loginName }
            error={ !isUserNameValid }
            helperText={ isUserNameValid ? '' : t('settings.loginName.missing') }
          />
          <TextField
            onPaste={ handleOnPaste }
            type="password"
            label={ t('registration.label.password') }
            className={ classes.textField }
            onChange={ handleOnChangePassword }
          />
          <TextField
            onPaste={ handleOnPaste }
            type="password"
            label={ t('registration.label.password_again') }
            className={ classes.textField }
            onChange={ handleOnChangePasswordAgain }
          />
          <FormControlLabel
            control={ <Checkbox
              className={ classes.checkBox }
              checked={ gdpr }
              onChange={ handleGdprChecked }
              name="GDPR" />
            }
            label={ <Typography className={ classes.gdprText } variant="body1">
              {t('registration.label.gdpr.text')}
              <a
                href={ PRIVACY_POLICY }
                target='_blank'
                rel="noreferrer"
              >
                {t('registration.label.gdpr.url_text')}
              </a>
            </Typography> }
          />
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end">
          <Button onClick={ handleRegister } color='primary' >
            { t('registration.button.register') }
          </Button>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Registration;
